<template>
<div ref="editToolbar">
  <div>
    <span class="topology-icon-group">
      <el-button size="medium" type="content" class="btn-setting mr-r4" @click="onMapAttrBtnClick">맵 속성</el-button>
      <span class="linked-icons mr-r15">
        <w-map-button type="button" icon="btn-obj" :toggle="true" tooltip="오브젝트 모음" @onClick="onObjectCollectBtnClick"></w-map-button>
        <w-map-button type="button" icon="btn-objsetting" :toggle="true" ref="objectAttrBtn" tooltip="오브젝트 속성" @onClick="onObjectAttrBtnClick"></w-map-button>
        <w-map-button type="button" icon="btn-align" :toggle="true" tooltip="정렬도구" @onClick="onAlignBtnClick"></w-map-button>
        <w-map-button type="button" icon="btn-minimap" :toggle="true" tooltip="미니맵" @onClick="onMinimapBtnClick"></w-map-button>
      </span>
      <span class="linked-icons mr-r15">
        <w-map-button type="button" icon="btn-select" :pressed="orgInteractionMode === MapConst.INTERACTION.EDIT_SELECTION" tooltip="기본 편집 모드" @onClick="onEditSelectionModeBtnClick"></w-map-button>
        <w-map-button type="button" icon="btn-move" :pressed="orgInteractionMode === MapConst.INTERACTION.EDIT_MOVE" tooltip="이동 모드" @onClick="onEditMoveModeBtnClick"></w-map-button>
      </span>
      <span class="linked-icons mr-r15">
        <w-map-button type="button" icon="btn-back" tooltip="되돌리기" @onClick="onUndoBtnClick"></w-map-button>
        <w-map-button type="button" icon="btn-copy" tooltip="복사" @onClick="onCopyBtnClick"></w-map-button>
        <w-map-button type="button" icon="btn-paste" tooltip="붙여넣기" @onClick="onPasteBtnClick"></w-map-button>
      </span>
      <span class="linked-icons mr-r15" v-if="isAutomap">
        <w-map-button type="button" icon="btn-layout-radial" tooltip="방사형 레이아웃" @onClick="onLayoutBtnClick(MapConst.LAYOUT_TYPE.RADIAL)" :disabled="!currentMapId"></w-map-button>
        <w-map-button type="button" icon="btn-layout-circle" tooltip="원형 레이아웃" @onClick="onLayoutBtnClick(MapConst.LAYOUT_TYPE.CIRCLE)" :disabled="!currentMapId"></w-map-button>
        <!-- <w-map-button type="button" icon="btn-layout-tree" tooltip="트리형 레이아웃" @onClick="onLayoutBtnClick(MapConst.LAYOUT_TYPE.TREE)" :disabled="!currentMapId"></w-map-button> -->
        <!-- <w-map-button type="button" icon="btn-layout-tree" tooltip="계층형 레이아웃" @onClick="onLayoutBtnClick(MapConst.LAYOUT_TYPE.HIERARCHIC)" :disabled="!currentMapId"></w-map-button> -->
      </span>
      <span class="linked-icons mr-r15">
        <w-map-button type="button" icon="btn-auto" tooltip="화면에 맞춰 표시" @onClick="onZoomFitBtnClick"></w-map-button>
        <w-map-button type="button" icon="btn-fit" tooltip="원래 크기로 표시" @onClick="onZoomResetBtnClick"></w-map-button>
      </span>
    </span>
    <el-button type="primary" class="mr-r3" size="small" @click="onMapSaveBtnClick"> 저장 </el-button>
    <el-button type="content" size="small" @click="onMapExitBtnClick"> 취소 </el-button>
  </div>
</div>
</template>

<script>
import forEach from 'lodash/forEach';
import reduce from 'lodash/reduce';
import filter from 'lodash/filter';
import merge from 'lodash/merge';
import uniq from 'lodash/uniq';
import map from 'lodash/map';
import cloneDeep from 'lodash/cloneDeep';

import MapAPI from '@/api/topologymap/common';

import MapConst from '@/constants/topologymap';

import Toolbar from '@/mixins/topologymap/toolbar';

import msgUtil from '@/utils/message';
import { isTrue } from '@/utils/boolean';

import WMapButton from '@/views/topologymap/components/MapButton';
import WMinimapWindow from '@/views/topologymap/components/monitoring/MinimapWindow';
import WAlignToolWindow from '@/views/topologymap/components/edit/AlignToolWindow';
import WObjectElementWindow from '@/views/topologymap/components/edit/ObjectElementWindow';
import WObjectPropertyWindow from '@/views/topologymap/components/edit/ObjectPropertyWindow';
import { Q, MapInfo, MapUtil, MapPopup } from '@/views/topologymap/js/maps';
import { isEmpty } from '@/utils/basic';
import Base from '@/mixins/topologymap/base';

export default {
  name: 'WTopologymapEdit',
  components: {
    WObjectPropertyWindow,
    WObjectElementWindow,
    WMapButton,
    WAlignToolWindow,
  },
  mixins: [Toolbar, Base],
  data() {
    return {
      orgInteractionMode: MapConst.INTERACTION.EDIT_SELECTION,
      MapConst,
      rightClickEvent: null,
    };
  },
  created() {
    MapInfo.getInstance(this).setToolbar(MapConst.VIEW_MODE.EDIT, this);

    // 오브젝트가 추가/삭제되는것 감지해서 장비연결 아이콘 상태 업데이트
    MapInfo.getInstance(this).getGraph().listChangeDispatcher.addListener(this.updateConnectExpandState);
  },
  methods: {
    /**
     * 맵 속성 버튼 클릭
     * @author KangBonghun(toto1323)
     */
    onMapAttrBtnClick() {
      MapInfo.getInstance(this).getPanel().$refs.mapPropertyPopup.open({
        type: 'EDIT',
        model: MapInfo.getInstance(this).getGraph().topologymapModel,
      });
    },
    /**
     * 오브젝트 모음 버튼 클릭
     * @author KangBonghun(toto1323)
     * @param  {[type]} btn [description]
     */
    onObjectCollectBtnClick(btn) {
      this.toggleWindowButton(WObjectElementWindow, btn);
    },
    /**
     * 오브젝트 속성 버튼 클릭
     * @author KangBonghun(toto1323)
     * @param  {[type]} btn [description]
     */
    onObjectAttrBtnClick(btn) {
      this.toggleWindowButton(WObjectPropertyWindow, btn);
    },
    /**
     * 정렬도구 버튼 클릭
     * @author KangBonghun(toto1323)
     * @param  {[type]} btn [description]
     */
    onAlignBtnClick(btn) {
      this.toggleWindowButton(WAlignToolWindow, btn);
    },
    /**
     * 미니맵 버튼 클릭
     * @author KangBonghun(toto1323)
     * @param  {[type]} btn [description]
     */
    onMinimapBtnClick(btn) {
      this.toggleWindowButton(WMinimapWindow, btn);
    },
    /**
     * 영역 선택 모드 버튼 클릭
     * @author KangBonghun(toto1323)
     */
    onEditSelectionModeBtnClick() {
      const graph = MapInfo.getInstance(this).getGraph();
      graph.interactionMode = MapConst.INTERACTION.EDIT_SELECTION;
      this.orgInteractionMode = graph.interactionMode;
    },
    /**
     * 이동 모드 버튼 클릭
     * @author KangBonghun(toto1323)
     */
    onEditMoveModeBtnClick() {
      const graph = MapInfo.getInstance(this).getGraph();
      graph.interactionMode = MapConst.INTERACTION.EDIT_MOVE;
      this.orgInteractionMode = graph.interactionMode;
    },
    /**
     * 되돌리기 버튼 클릭
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onUndoBtnClick() {
      MapInfo.getInstance(this).undoEditHistory();
    },
    /**
     * 복사 버튼 클릭
     * @author KangBonghun(toto1323)
     */
    onCopyBtnClick() {
      this.onCopy();
    },
    /**
     * 붙여넣기 버튼 클릭
     * @author KangBonghun(toto1323)
     */
    onPasteBtnClick() {
      this.onPaste();
    },
    /**
     * 자동 확대/축소 버튼 클릭
     * @author KangBonghun(toto1323)
     */
    onZoomFitBtnClick() {
      MapInfo.getInstance(this).getCanvas().zoomFit();
    },
    /**
     * 기본 확대/축소 버튼 클릭
     * @author KangBonghun(toto1323)
     */
    onZoomResetBtnClick() {
      MapInfo.getInstance(this).getCanvas().zoomReset();
    },
    onLayoutBtnClick(type) {
      MapInfo.getInstance(this).getCanvas().doAutoLayout(type, true);
    },
    /**
     * 나가기 버튼 클릭
     * @author KangBonghun(toto1323)
     */
    onMapExitBtnClick() {
      this.$confirm(...msgUtil.getCustomConfirmData('나가시겠습니까?'))
        .then(() => {
          this.$store.commit('setTopologymapViewMode', MapConst.VIEW_MODE.MONITORING);
          this.treeLoad();
        })
        .catch(() => {});
    },
    /**
     * 저장 버튼 클릭
     * @author KangBonghun(toto1323)
     */
    onMapSaveBtnClick() {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.SAVE))
        .then(() => {
          this.onMapSave(() => {
            try {
              const selectedNode = this.mapTreeSelectedNode;
              const graph = MapInfo.getInstance(this).getGraph();
              if (selectedNode && graph) {
                const currentMapLabel = graph.topologymapModel.label;
                if (currentMapLabel) {
                  selectedNode.label = currentMapLabel;
                }
              }
              this.treeLoad();
            } catch (e) {
              Q.log(e);
            }
            this.$store.commit('setTopologymapViewMode', MapConst.VIEW_MODE.MONITORING);
          });
        })
        .catch(() => {});
    },
    /**
     * 툴바가 활성화되면 호출된다. (편집모드로 전환된 경우)
     * @author KangBonghun(toto1323)
     */
    onActivateToolbar() {
      const graph = MapInfo.getInstance(this).getGraph();

      if (graph) {
        graph.interactionMode = MapConst.INTERACTION.EDIT_SELECTION;
        graph.editable = true;

        this.orgInteractionMode = graph.interactionMode;
        this.refreshGraphModelForEdit();

        // 간혹 모니터링의 우클릭 포인터가 남아있는 현상이 있어서 명시적으로 포인터를 제거한다.
        graph.canvasPanel.classList.remove('topology-right-click');

        // 회선 하이라이트 초기화
        this.highlightLan();

        // 편집모드에 진입하면 맵에 그려진 관리대상들에 대한 연결정보를 미리 로드한다.
        this.loadConnectInfo();
      }

      // 편집모드에서는 맵 트리를 숨긴다.
      this.$store.commit('setMapTreeCollapse', true);

      // 장비주요정보 팝업창 close
      this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.MAJOR_INFO, null);
      this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.AUTOMAP_MAJOR_INFO, null);

      // 오브젝트 추가 모드 기본 값으로 변경
      this.$store.commit('setAttachMode', MapConst.ATTACH_MODE.ADD);
    },
    /**
     * // 연결정보 로드
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    loadConnectInfo() {
      if (this.isAutomap) {
        return;
      }

      window.ipaddressToConnectInfo = {};
      const graph = MapInfo.getInstance(this).getGraph();
      graph.callLater(() => {
        const ipaddressList = reduce(graph.graphModel.toDatas(), (result, value) => {
          if (value instanceof Q.ManagedObjectModel) {
            const model = value.get('model');
            result.push(model.ipaddress);
          }
          return result;
        }, []);
        MapAPI.getConnectInfo(ipaddressList).then((response) => {
          const result = response.data;
          if (result.success) {
            window.ipaddressToConnectInfo = result.data;

            this.updateConnectExpandState();
          }
        });
      });
    },
    /**
     * 맵에 구성 된 모든 관리대상에 대해 장비연결 아이콘 상태를 업데이트한다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    updateConnectExpandState() {
      // graph의 listChangeDispatcher 이벤트를 통해서 호출되는 경우에는 굉장히 빈번히 호출되므로 부하를 유발한다. 따라서 일정시간 지난 후에 한번만 수행하도록 조치
      if (window.updateConnectExpandStateTimeout) {
        clearTimeout(window.updateConnectExpandStateTimeout);
        window.updateConnectExpandStateTimeout = null;
      }
      window.updateConnectExpandStateTimeout = setTimeout(() => {
        const graph = MapInfo.getInstance(this).getGraph();
        forEach(graph.graphModel.toDatas(), (element) => {
          if (element instanceof Q.ManagedObjectModel) {
            element.updateExpandState();
          }
        });
      }, 100);
    },
    /**
     * 오브젝트를 편집하기 위해 이벤트/성능/범례를 적용시키지 않은 상태로 새로고침한다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    refreshGraphModelForEdit() {
      const graph = MapInfo.getInstance(this).getGraph();
      const data = graph.topologymapModel;
      const canvas = MapInfo.getInstance(this).getCanvas();

      const modelData = {
        imageModels: data.imageModels || [],
        labelModels: data.labelModels || [],
        lanModels: data.lanModels || [],
        managedObjectModels: data.managedObjectModels || [],
        shapeModels: data.shapeModels || [],
        subTopologymapModels: data.subTopologymapModels || [],
        virtualLanModels: data.virtualLanModels || [],
        virtualObjectModels: data.virtualObjectModels || [],
        custom1Models: data.custom1Models || [],
      };
      canvas.refreshGraphModel(modelData);
    },
    /**
     * 선택 된 오브젝트를 복사한다.
     * @author KangBonghun(toto1323)
     */
    onCopy() {
      const selection = MapInfo.getInstance(this).getGraph().selectionModel.toDatas();
      if (this.isAutomap) {
        const copyElements = filter(selection, (target) => {
          let copiable = true;

          if (target instanceof Q.ManagedObjectModel) {
            copiable = !(target.get('isAutomapDevice') === true);
          } else if (target instanceof Q.LanModel) {
            copiable = !(target.get('isSrcAutomapTarget') === true || target.get('isDstAutomapTarget') === true);
          }
          return copiable;
        });
        window.copyElements = copyElements; // 성능상 이점이 있어서 전역 객체에 저장한다.
        this.$message.info(`연결장비를 제외하고 ${copyElements.length}개가 복사되었습니다.`);
      } else {
        window.copyElements = selection;
        this.$message.info(`${selection.length}개가 복사되었습니다.`);
      }
    },
    /**
     * 복사 된 오브젝트를 붙여넣기한다.
     * @author KangBonghun(toto1323)
     * @param  {MouseEvent} event [description]
     */
    onPaste(event) {
      if (isEmpty(window.copyElements)) { // 복사 된 오브젝트가 없으면 수행하지 않는다.
        return;
      }

      const graph = MapInfo.getInstance(this).getGraph();
      const dx = 20;
      const dy = 20;
      const newElements = [];
      const oldIdToNewElement = {};
      let maxZIndex = this.getMaxZIndex();
      let newX = null;
      let newY = null;

      if (event) {
        const convertedPoint = this.convertsToLogicalPointFromMouseEvent(event);
        newX = convertedPoint && convertedPoint.x;
        newY = convertedPoint && convertedPoint.y;
      }

      const nodeElements = window.copyElements.filter((element) => element instanceof Q.Node);
      const edgeElements = window.copyElements.filter((element) => element instanceof Q.Edge);

      // 오브젝트 생성
      nodeElements.forEach((node) => {
        maxZIndex += 1;

        const newModel = MapUtil.clone(node.get('model'));
        newModel.elementId = null;
        newModel.x = newX || node.x + dx;
        newModel.y = newY || node.y + dy;
        newModel.z = maxZIndex;

        const newElement = new node.class(newModel); // eslint-disable-line
        newElements.push(newElement);
        oldIdToNewElement[node.id] = newElement;

        graph.addElement(newElement);
      });

      // 선 연결. 반드시 오브젝트를 생성 후에 연결해야한다.
      edgeElements.forEach((edge) => {
        const from = oldIdToNewElement[edge.from.id];
        const to = oldIdToNewElement[edge.to.id];

        if (from && to) {
          const newModel = MapUtil.clone(edge.get('model'));
          newModel.elementId = null;
          const newElement = new edge.class(newModel, from, to); // eslint-disable-line
          newElements.push(newElement);

          graph.addElement(newElement);
        }
      });

      // 붙여넣기 한 오브젝트를 선택한 상태로 변경하고 복사한다.
      graph.setSelection(newElements);
      window.copyElements = MapInfo.getInstance(this).getGraph().selectionModel.toDatas();

      MapInfo.getInstance(this).addEditHistory({
        type: MapConst.HISTORY_TYPE.ADD,
        elements: newElements,
      });
    },
    /**
     * 그래프에서 감지 한 마우스이벤트에서 지역 좌표로 변경 한 좌표를 반환한다.
     * @author KangBonghun(toto1323)
     * @param  {MouseEvent} event [description]
     * @return {Object}       [description]
     */
    convertsToLogicalPointFromMouseEvent(event) {
      let convertedPoint;
      if (event) {
        const graph = MapInfo.getInstance(this).getGraph();
        const p = graph.globalToLocal(event);
        const l = graph.toLogical(p.x, p.y);

        convertedPoint = l;
      }
      return convertedPoint;
    },
    /**
     * 현재 그려진 오브젝트에서 z-index 최대값을 반환한다.
     * @author KangBonghun(toto1323)
     * @return {Number} z-index 최대값
     */
    getMaxZIndex() {
      const gm = MapInfo.getInstance(this).getGraph().graphModel;

      const maxZIndex = Math.max.apply(Math, gm.toDatas().map((o) => o.zIndex || 0)); // eslint-disable-line

      return isNaN(maxZIndex) ? 1 : maxZIndex;
    },
    /**
     * 편집 내용 저장
     * @author KangBonghun(toto1323)
     * @param  {Function} cbFunc 성공적으로 저장 후 호출되는 콜백함수
     */
    onMapSave(cbFunc) {
      MapInfo.getInstance(this).mask('저장중...');

      const graph = MapInfo.getInstance(this).getGraph();
      const graphModels = graph.graphModel.toDatas();
      const topologymap = graph.topologymapModel;
      topologymap.imageModels = [];
      topologymap.labelModels = [];
      topologymap.lanModels = [];
      topologymap.managedObjectModels = [];
      topologymap.subTopologymapModels = [];
      topologymap.virtualLanModels = [];
      topologymap.virtualObjectModels = [];
      topologymap.shapeModels = [];
      topologymap.custom1Models = [];

      if (graphModels) {
        graphModels.forEach((item) => {
          try {
            const model = item.get('model');

            if (item instanceof Q.ImageModel) {
              topologymap.imageModels.push(model);
            } else if (item instanceof Q.LabelModel) {
              topologymap.labelModels.push(model);
            } else if (item instanceof Q.LanModel) {
              topologymap.lanModels.push(model);
            } else if (item instanceof Q.ManagedObjectModel) {
              topologymap.managedObjectModels.push(model);
            } else if (item instanceof Q.SubTopologymapModel) {
              topologymap.subTopologymapModels.push(model);
            } else if (item instanceof Q.VirtualLanModel) {
              topologymap.virtualLanModels.push(model);
            } else if (item instanceof Q.VirtualObjectModel) {
              topologymap.virtualObjectModels.push(model);
            } else if (item instanceof Q.ShapeModel) {
              topologymap.shapeModels.push(model);
            } else if (item instanceof Q.Custom1Model) {
              topologymap.custom1Models.push(model);
            }
          } catch (e) {
            Q.log(e);
          }
        });
      }

      MapAPI.updateTopologymap(topologymap).then((response) => {
        const result = response.data;
        if (result.success) {
          // 저장 화면 캡쳐
          this.onSaveMapCapture(() => {
            cbFunc.call();
            this.$nextTick(() => {
              this.$message('저장하였습니다.');
            });
            // this.$alert('저장하였습니다.', '정보', {
            //   confirmButtonText: '확인',
            //   callback: cbFunc,
            // });
          });
        } else {
          cbFunc.call();
          this.$nextTick(() => {
            this.$message('저장을 실패하였습니다.');
          });
          // this.$alert('저장을 실패하였습니다.', '정보', {
          //   confirmButtonText: '확인',
          //   callback: cbFunc,
          // });
        }
        MapInfo.getInstance(this).unmask();
      });
    },
    /**
     * 저장 시점의 화면을 캡쳐해서 저장한다.
     * @author KangBonghun(toto1323)
     * @param  {Function} cbFunc 성공 후 호출되는 콜백함수
     */
    onSaveMapCapture(cbFunc) {
      const graph = MapInfo.getInstance(this).getGraph();
      graph.unselectAll();

      MapInfo.getInstance(this).exportImage((base64) => {
        if (cbFunc) {
          cbFunc.call();
        }

        if (base64) {
          MapAPI.updateTopologymapCapture(graph.topologymapModel.mapId, base64);
        }
      });
    },
    /**
     * 우클릭 했을 때 호출되며 컨텍스트 메뉴를 업데이트한다.
     * @author KangBonghun(toto1323)
     * @param  {[type]} evt [description]
     * @return {[type]}     [description]
     */
    oncontextmenu(evt) {
      this.rightClickEvent = evt;
      const target = evt.getData();

      // 오브젝트에 우클릭 할 경우에만 컨텍스트 메뉴를 보여준다.
      const items = this.getContextMenu(target);

      if (items && items.length > 0) {
        // 스토어에 컨텍스트 메뉴 전달
        this.$store.dispatch('showContextmenu', {
          items,
          evt,
          target: this,
          graph: MapInfo.getInstance(this).getGraph(),
        });
      }
    },
    /**
     * 조건에 따라 컨텍스트 메뉴 아이템 목록을 반환한다.
     * @author KangBonghun(toto1323)
     * @param  {[type]} target 선택 된 오브젝트
     * @return {Array}        컨텍스트 메뉴 아이템 목록
     */
    getContextMenu(target) {
      const graph = MapInfo.getInstance(this).getGraph();
      let items = [];

      if (target) { // 오브젝트가 있는 곳에서 우클릭 시
        // 오브젝트 속성창이 닫혀진 상태이면 메뉴에 포함시킨다.
        const propertyPopup = MapPopup.getPopup(WObjectPropertyWindow.name);
        if (!propertyPopup.wrapper || propertyPopup.wrapper.$el.style.visibility === 'hidden') {
          items.push({
            label: '속성',
            type: MapConst.CONTEXT_EDIT.PROPERTY,
          });
        }

        if (target instanceof Q.LanModel) {
          if (target.properties.lineDirection !== 'SEGMENT_CURVE_TO') {
            items.push({
              label: '꺾은점 추가',
              type: MapConst.CONTEXT_EDIT.POINT,
            });
          }
        } else {
          items.push(
            {
              label: '맨 앞으로 가져오기',
              type: MapConst.CONTEXT_EDIT.SEND_TO_TOP,
            },
            {
              label: '맨 뒤로 보내기',
              type: MapConst.CONTEXT_EDIT.SEND_TO_BOTTOM,
            },
            {
              label: '복사',
              type: MapConst.CONTEXT_EDIT.COPY,
            },
            {
              label: '붙여넣기',
              type: MapConst.CONTEXT_EDIT.PASTE,
            },
          );
        }

        // 노드 엘리먼트가 2개 이상일 때만 선연결을 보여준다.
        const selectionModel = graph.selectionModel;
        if (selectionModel && selectionModel.toDatas() && selectionModel.toDatas().length > 0) {
          const nodeArray = selectionModel.toDatas().filter((value) => value instanceof Q.Node);
          if (nodeArray && nodeArray.length > 1) {
            items.push({
              label: '선 연결',
              type: MapConst.CONTEXT_EDIT.LAN,
            });
          }
        }
      } else if (!isEmpty(window.copyElements)) { // 오브젝트가 없는 곳에서 우클릭했고, 복사한 오브젝트가 있을 경우
        items = [
          {
            label: '붙여넣기',
            type: MapConst.CONTEXT_EDIT.PASTE,
          },
        ];
      }
      return items;
    },
    /**
     * 컨텍스트 메뉴 아이템을 선택하면 호출된다.
     * @author KangBonghun(toto1323)
     * @param  {Object} item 선택한 메뉴
     * @param  {[type]} evt  [description]
     * @return {[type]}      [description]
     */
    onContextMenuItemSelect(item, evt) {
      switch (item.type) {
        case MapConst.CONTEXT_EDIT.PROPERTY:
          this.$refs.objectAttrBtn.selected = true;
          this.onObjectAttrBtnClick(this.$refs.objectAttrBtn);
          break;
        case MapConst.CONTEXT_EDIT.SEND_TO_TOP:
          WAlignToolWindow.methods.sendToTop.call(this);
          break;
        case MapConst.CONTEXT_EDIT.SEND_TO_BOTTOM:
          WAlignToolWindow.methods.sendToBottom.call(this);
          break;
        case MapConst.CONTEXT_EDIT.COPY:
          this.onCopy();
          break;
        case MapConst.CONTEXT_EDIT.PASTE:
          this.onPaste(evt);
          break;
        case MapConst.CONTEXT_EDIT.LAN:
          this.createLan();
          break;
        case MapConst.CONTEXT_EDIT.POINT:
          this.addPoint();
          break;
        default:
      }
    },
    /**
     * 키업다운 이벤트
     * 입력 된 키에따라 interactionMode를 변경한다.
     * @author KangBonghun(toto1323)
     * @param  {[type]} evt   [description]
     * @param  {[type]} graph [description]
     * @return {[type]}       [description]
     */
    onkeyupdown(evt, graph) {
      if (graph.editable) {
        if (evt.key === 'l') { // 선 연결 상태로 변경
          if (evt.type === 'keydown') {
            graph.interactionMode = MapConst.INTERACTION.EDIT_LINE;
          } else {
            graph.interactionMode = this.orgInteractionMode;
          }
        } else if (evt.code === 'Space') { // 이동 상태로 변경
          if (evt.type === 'keydown') {
            graph.interactionMode = MapConst.INTERACTION.EDIT_MOVE;
          } else {
            graph.interactionMode = this.orgInteractionMode;
          }
        }
      }
    },
    /**
     * 키다운 이벤트
     * @author KangBonghun(toto1323)
     * @param  {[type]} evt   [description]
     * @param  {[type]} graph [description]
     * @return {[type]}       [description]
     */
    onkeydown(evt, graph) {
      if (graph.editable) {
        const keyCode = evt.keyCode;

        // 오브젝트 삭제
        // 8: 백스페이스, 46: DELETE, 127: F16
        if (keyCode === 8 || keyCode === 46 || keyCode === 127) {
          const models = graph.selectionModel.toDatas();
          if (models && models.length !== 0) {
            if (this.isAutomap) {
              const e = graph.removeSelectionAutomap();
              if (e) {
                if (models.length !== e.length) {
                  this.$message.info(`연결장비를 제외하고 ${e.length}개가 삭제되었습니다.`);
                }
                const i = new Q.InteractionEvent(graph, Q.InteractionEvent.ELEMENT_REMOVED, evt, e);
                graph.onInteractionEvent(i);
                this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.REMOVE_ELEMENT_COMPLETE);
              } else {
                this.$message.error('연결장비는 삭제 할 수 없습니다.');
              }
            } else {
              const e = graph.removeSelection();
              if (e) {
                const i = new Q.InteractionEvent(graph, Q.InteractionEvent.ELEMENT_REMOVED, evt, e);
                graph.onInteractionEvent(i);
                this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.REMOVE_ELEMENT_COMPLETE);
              }
            }
          }
          Q.eventPreventDefault(evt);
        }

        // 오브젝트 키보드 이동
        /* eslint-disable */
        // jshint ignore: start
        var i, n;
        //37: Left, 39: Right, 38: Up, 40: Down
        if ((37 == keyCode ? (i = -1) : 39 == keyCode ? (i = 1) : 38 == keyCode ? (n = -1) : 40 == keyCode && (n = 1), i || n)) {
          var s = Q.MoveInteraction.prototype._1z(graph).toDatas();
          if (0 != s.length) {
            Q.eventPreventDefault(evt), (i = i || 0), (n = n || 0);
            var o = 1 / graph.scale,
              r = new Q.InteractionEvent(graph, Q.InteractionEvent.ELEMENT_MOVE_START, evt, null, s);
            graph.moveElements(s, i * o, n * o), graph.onInteractionEvent(r);
          }
        }
        /* eslint-enable */
        // jshint ignore: end

        // 오브젝트 복사/붙여넣기/되돌리기
        if (Q.isMetaKey(evt)) {
          // 67: C, 86: V, 90: Z, 88: X
          if (keyCode === 67 || keyCode === 86 || keyCode === 90 || keyCode === 88) {
            if (keyCode === 67) {
              this.onCopy();
            } else if (keyCode === 86) {
              this.onPaste();
            } else if (keyCode === 90) {
              MapInfo.getInstance(this).undoEditHistory();
            }
            Q.eventPreventDefault(evt);
          }
        }

        // 선 연결
        // 76: L
        if (keyCode === 76) {
          this.createLan();
        }
      }
    },
    /**
     * 오브젝트 클릭
     * @author KangBonghun(toto1323)
     * @param  {[type]} evt    [description]
     * @param  {[type]} target [description]
     * @param  {[type]} graph  [description]
     * @return {[type]}        [description]
     */
    onClickTarget(evt, target, graph) {
      // 편집모드에서 장비연결 아이콘을 클릭했을 경우
      const hitTarget = graph.hitTest(evt);
      if (hitTarget && hitTarget.name === 'connectExpand') {
        hitTarget.data = 'connecting.svg';
        target.invalidate();

        // 클릭한 장비
        const oldElement = target;

        // 연결해야 할 장비 IP 목록
        const disconnectIps = uniq(map(oldElement.disconnectList, 'remoteIpaddress'));
        // 기존에 그려져 있는 장비 목록
        const ipaddressToOldElements = this.getIpaddressToOldElements();
        // 연결해야 할 장비 중 그려져 있지 않은 장비 IP 목록
        const nonExistElementIps = filter(disconnectIps, (disconnectIp) => !ipaddressToOldElements[disconnectIp]);

        // 새로 추가 할 장비 정보 조회
        MapAPI.getObjInfoList(nonExistElementIps).then((response) => {
          const result = response.data;

          if (result.success) {
            // 추가 할 장비 Element 생성
            const newElements = this.createManagedObjectModel(result.data, { x: oldElement.x, y: oldElement.y });

            // 장비 추가 및 연결
            this.addAndConnectElement(graph, newElements, [oldElement]);

            // 추가 된 장비 방사형으로 위치 조정
            let angle = 0;
            let radian = 0;
            const radianIncrementor = ((360 / newElements.length) * Math.PI) / 180;
            const distance = 150;
            newElements.forEach((newElement) => {
              const newModel = newElement.get('model');

              radian += radianIncrementor;

              if (angle >= 2 * Math.PI) {
                angle -= 2 * Math.PI;
              }

              newModel.x = Number(oldElement.x + (distance * Math.cos(radian)));

              if (newElements.length === 1) {
                newModel.y = oldElement.y;
              } else {
                newModel.y = Number(oldElement.y + (distance * Math.sin(radian)));
              }
              newElement.update();
            });
          }
        });
      }
    },
    /**
     * 선택 된 오브젝트끼리 선을 연결시킨다.
     * @author KangBonghun(toto1323)
     */
    createLan() {
      const graph = MapInfo.getInstance(this).getGraph();
      const selectionModels = graph.selectionModel.toDatas();
      const nodeModels = selectionModels.filter((model) => model instanceof Q.Node);

      if (nodeModels.length >= 2) {
        const elements = [];
        const fromNode = nodeModels[0];

        for (let i = 1; i < nodeModels.length; i += 1) {
          const toNode = nodeModels[i];

          const element = new Q.LanModel({}, fromNode, toNode);
          elements.push(element);

          graph.addElement(element);
        }

        MapInfo.getInstance(this).addEditHistory({
          type: MapConst.HISTORY_TYPE.ADD,
          elements,
        });
      }
    },
    addPoint() {
      const { rightClickEvent } = this;
      if (!isEmpty(rightClickEvent)) {
        const logicalPoint = this.convertsToLogicalPointFromMouseEvent(rightClickEvent);
        rightClickEvent.getUI().addPoint(logicalPoint.x, logicalPoint.y);
      }
    },
    /**
     * 오브젝트가 그래프(Canvas)로 Drop하면 오브젝트를 그래프에 그린다.
     * @author KangBonghun(toto1323)
     * @param  {[type]} modelType 오브젝트 타입
     * @param  {[type]} point     Drop 좌표
     * @param  {[type]} objects   오브젝트 목록
     * @param  {[type]} evt       [description]
     */
    onDragAndDrop(modelType, point, objects, evt) {
      const graph = MapInfo.getInstance(this).getGraph();
      const attachMode = this.$store.getters.getAttachMode;
      const self = this;

      let newElements = [];

      switch (modelType) {
        case Q.ManagedObjectModel:
          newElements = self.createManagedObjectModel(objects, point);
          break;
        case Q.VirtualObjectModel:
          newElements = self.createVirtualObjectModel(objects, point);
          break;
        case Q.VirtualLanModel:
          newElements = self.createVirtualLanModel(objects, point);
          break;
        case Q.SubTopologymapModel:
          newElements = self.createSubTopologymapModel(objects, point);
          break;
        case Q.ShapeModel:
          newElements = self.createShapeModel(objects, point);
          break;
        case Q.ImageModel:
          newElements = self.createImageModel(objects, point);
          break;
        case Q.LabelModel:
          newElements = self.createLabelModel(objects, point);
          break;
        case Q.Custom1Model:
          newElements = self.createCustom1Model(objects, point);
          break;
        default:
      }

      switch (attachMode) {
        case MapConst.ATTACH_MODE.REPLACE: {
          const oldElement = graph.getElementByMouseEvent(evt);
          const newElement = newElements && newElements[0];

          if (newElement) {
            if (oldElement && !(oldElement instanceof Q.VirtualLanModel) && !(oldElement instanceof Q.LanModel) && !(newElement instanceof Q.VirtualLanModel)) {
              if (oldElement.get('isAutomapDevice')) {
                this.$message.error('연결장비에는 교체 할 수 없습니다.');
                return;
              }
              const newModel = newElement.get('model');
              const oldModel = oldElement.get('model');
              newModel.width = oldElement.size.width;
              newModel.height = oldElement.size.height;
              newModel.x = oldElement.x;
              newModel.y = oldElement.y;
              newModel.customimageId = newModel.customimageId > 0 ? newModel.customimageId : oldModel.customimageId;
              newElement.update();

              graph.addElement(newElement);
              oldElement.getEdges().forEach((edge) => {
                edge.changeAgent(edge.from === oldElement ? 'SRC' : 'DST', newElement);
              });
              graph.removeElement(oldElement);

              MapInfo.getInstance(this).addEditHistory({
                type: MapConst.HISTORY_TYPE.REPLACE,
                oldElement,
                newElement,
              });
            } else {
              graph.addElement(newElement);

              MapInfo.getInstance(this).addEditHistory({
                type: MapConst.HISTORY_TYPE.ADD,
                elements: newElement,
              });
            }
            this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.ADD_ELEMENT_COMPLETE);
          }
          break;
        }
        case MapConst.ATTACH_MODE.CONNECT: {
          // 연결 기능은 관리대상일 경우에만 동작하고 아니면 그냥 추가 동작
          if (modelType === Q.ManagedObjectModel) {
            this.addAndConnectElement(graph, newElements);
          } else if (newElements) {
            newElements.forEach((element) => {
              graph.addElement(element);
            });
            graph.setSelection(newElements);

            MapInfo.getInstance(this).addEditHistory({
              type: MapConst.HISTORY_TYPE.ADD,
              elements: newElements,
            });

            this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.ADD_ELEMENT_COMPLETE);
          }
          break;
        }
        case MapConst.ATTACH_MODE.ADD:
        default:
          if (newElements) {
            newElements.forEach((element) => {
              graph.addElement(element);
            });
            graph.setSelection(newElements);

            MapInfo.getInstance(this).addEditHistory({
              type: MapConst.HISTORY_TYPE.ADD,
              elements: newElements,
            });

            this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.ADD_ELEMENT_COMPLETE);
          }
      }
    },
    getIpaddressToOldElements() {
      const graph = MapInfo.getInstance(this).getGraph();
      const ipaddressToOldElements = reduce(graph.graphModel.toDatas(), (elements, value) => {
        if (value instanceof Q.ManagedObjectModel) {
          const model = value.get('model');
          if (!elements[model.ipaddress]) {
            elements[model.ipaddress] = [];
          }
          elements[model.ipaddress].push(value);
        }
        return elements;
      }, {});
      return ipaddressToOldElements;
    },

    /**
     * 장비를 추가하고 연결관계가 있는 장비끼리 회선을 연결시킨다.
     * @author KangBongHun(toto1323)
     * @param  {[type]} graph       Graph
     * @param  {[type]} newElements 추가 장비
     * @param  {[type]} oldElements  기존 장비
     */
    addAndConnectElement(graph, newElements, oldElements) {
      const newConnectIps = reduce(newElements, (result, value) => {
        result.push(value.get('model').ipaddress);
        return result;
      }, []);

      const lanElements = [];

      // 연결해야할 장비 정보 조회
      MapAPI.getConnectInfo(newConnectIps).then((response) => {
        const result = response.data;
        if (result.success) {
          // 전역변수 연결정보 업데이트
          merge(window.ipaddressToConnectInfo, result.data);

          // 기존에 그려진 오브젝트를 Map으로 만들어놓는다. loop 성능 최적화를 위해서..
          const ipaddressToOldElements = this.getIpaddressToOldElements();

          // 출발지 장비 목록
          const localElements = newElements || oldElements;
          forEach(localElements, (localElement) => {
            const localModel = localElement.get('model');
            const connectList = cloneDeep(window.ipaddressToConnectInfo[localModel.ipaddress]) || {};

            // 연결정보가 있다면
            if (connectList) {
              // 이미 연결되어있는 회선을 제외
              localElement.forEachEdge((edge) => {
                const localIpaddress = edge.fromAgent.get('ipaddress');
                const remoteIpaddress = edge.toAgent.get('ipaddress');
                const localIfIndex = edge.get('srcIfIndex');
                const remoteIfIndex = edge.get('dstIfIndex');
                const key1 = `${localIpaddress}/${localIfIndex}/${remoteIpaddress}/${remoteIfIndex}`;
                const key2 = `${remoteIpaddress}/${remoteIfIndex}/${localIpaddress}/${localIfIndex}`;
                delete connectList[key1];
                delete connectList[key2];
              });

              // 연결되어있지 않은 회선 연결
              forEach(connectList, (connectInfo) => {
                // 목적지 장비 목록
                const remoteElements = ipaddressToOldElements[connectInfo.remoteIpaddress] || [];
                forEach(remoteElements, (remoteElement) => {
                  if (remoteElement.get('objtypeId') === 'NETINTERFACE') {
                    return;
                  }
                  const model = {};
                  // 출발지 세팅
                  if (connectInfo.localObjId || connectInfo.localIfIndex) {
                    model.srcObjId = connectInfo.localObjId;
                    // model.srcObjName = connectInfo.localNetinterfaceName;
                    model.srcNetinterfaceName = connectInfo.localNetinterfaceName;
                    model.srcNetinterfaceDesc = connectInfo.localNetinterfaceDesc;
                    model.srcNetinterfaceAlias = connectInfo.localNetinterfaceAlias;
                    model.srcIfIndex = connectInfo.localIfIndex;
                    model.srcIpaddress = connectInfo.localIpaddress;
                  }
                  // 목적지 세팅
                  if (connectInfo.remoteObjId || connectInfo.remoteIfIndex) {
                    model.dstObjId = connectInfo.remoteObjId;
                    // model.dstObjName = connectInfo.remoteNetinterfaceName;
                    model.dstNetinterfaceName = connectInfo.remoteNetinterfaceName;
                    model.dstNetinterfaceDesc = connectInfo.remoteNetinterfaceDesc;
                    model.dstNetinterfaceAlias = connectInfo.remoteNetinterfaceAlias;
                    model.dstIfIndex = connectInfo.remoteIfIndex;
                    model.dstIpaddress = connectInfo.remoteIpaddress;
                  }

                  const newLanElement = new Q.LanModel(model, localElement, remoteElement);
                  lanElements.push(newLanElement);
                });
              });
            }
          });
        }
      }).finally(() => {
        if (newElements) {
          newElements.forEach((element) => {
            graph.addElement(element);
          });
          graph.setSelection(newElements);
        }
        if (lanElements) {
          lanElements.forEach((element) => {
            graph.addElement(element);
          });
        }

        MapInfo.getInstance(this).addEditHistory({
          type: MapConst.HISTORY_TYPE.ADD,
          elements: isEmpty(newElements) ? lanElements : newElements.concat(lanElements),
        });

        this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.ADD_ELEMENT_COMPLETE);

        if (newElements && oldElements) {
          graph.callLater(() => {
            this.addAndConnectElement(graph, null, oldElements);
          });
        }
      });
    },
    /**
     * 관리대상 오브젝트 생성
     * @author KangBonghun(toto1323)
     * @param  {Array} objects 오브젝트 목록
     * @param  {Object} point   생성 할 좌표
     * @return {[type]}         [description]
     */
    createManagedObjectModel(objects, point) {
      const elements = [];
      let maxZIndex = this.getMaxZIndex();

      objects.forEach((object, index) => {
        const size = object.objtypeId === 'NETINTERFACE' ? 32 : 46;
        const gap = 10;

        elements.push(
          new Q.ManagedObjectModel({
            objName: object.objName,
            objtypeId: object.objtypeId,
            objDefineId: object.objDefineId,
            width: size,
            height: size,
            x: point.x + ((size + gap) * (index % 10)),
            y: point.y + ((size + gap) * parseInt(index / 10, 10)),
            r: 0,
            z: (maxZIndex += 1),
            objId: object.objId,
            ipaddress: object.ipaddress || ((object.ipaddressApplytype && (object.ipaddressApplytype === 'IPv6')) ? object.ipaddressIpv6 : object.ipaddressIpv4),
            isObj: isEmpty(object.isObj) || isTrue(object.isObj),
          }),
        );
      });

      return elements;
    },
    /**
     * 가상객체 오브젝트 생성
     * @author KangBonghun(toto1323)
     * @param  {Array} objects 오브젝트 목록
     * @param  {Object} point   생성 할 좌표
     * @return {[type]}         [description]
     */
    createVirtualObjectModel(objects, point) {
      const elements = [];
      let maxZIndex = this.getMaxZIndex();

      objects.forEach((object, index) => {
        const size = 46;
        const gap = 10;

        elements.push(
          new Q.VirtualObjectModel({
            label: object.label,
            objtypeId: object.itemId,
            width: size,
            height: size,
            x: point.x + ((size + gap) * (index % 10)),
            y: point.y + ((size + gap) * parseInt(index / 10, 10)),
            r: 0,
            z: (maxZIndex += 1),
          }),
        );
      });

      return elements;
    },
    /**
     * 사용자 정의 위젯 생성
     * @author KangBonghun(toto1323)
     * @param  {Array} objects 오브젝트 목록
     * @param  {Object} point   생성 할 좌표
     * @return {[type]}         [description]
     */
    createCustom1Model(objects, point) {
      const elements = [];
      let maxZIndex = this.getMaxZIndex();

      objects.forEach((object, index) => {
        const size = 46;

        elements.push(
          new Q.Custom1Model({
            label: object.label,
            objtypeId: 'ETC',
            customimageId: object.customimageId,
            width: size,
            height: size,
            objIds: object.objIds,
            x: point.x + (size * (index % 10)),
            y: point.y + (size * parseInt(index / 10, 10)),
            r: 0,
            z: (maxZIndex += 1),
          }),
        );
      });

      return elements;
    },
    /**
     * 가상랜 오브젝트 생성
     * @author KangBonghun(toto1323)
     * @param  {Array} objects 오브젝트 목록
     * @param  {Object} point   생성 할 좌표
     * @return {[type]}         [description]
     */
    createVirtualLanModel(objects, point) {
      const elements = [];
      let maxZIndex = this.getMaxZIndex();

      objects.forEach((object, index) => {
        const size = 46;

        elements.push(
          new Q.VirtualLanModel({
            length: size,
            weight: 1,
            color: '#000000',
            x: point.x + (size * (index % 10)),
            y: point.y + (size * parseInt(index / 10, 10)),
            r: 0,
            z: (maxZIndex += 1),
          }),
        );
      });

      return elements;
    },
    /**
     * 하위맵 오브젝트 생성
     * @author KangBonghun(toto1323)
     * @param  {Array} objects 오브젝트 목록
     * @param  {Object} point   생성 할 좌표
     * @return {[type]}         [description]
     */
    createSubTopologymapModel(objects, point) {
      const elements = [];
      let maxZIndex = this.getMaxZIndex();

      objects.forEach((object, index) => {
        const size = 46;

        elements.push(
          new Q.SubTopologymapModel({
            mapName: object.label,
            width: size,
            height: size,
            x: point.x + (size * (index % 10)),
            y: point.y + (size * parseInt(index / 10, 10)),
            r: 0,
            z: (maxZIndex += 1),
            mapId: object.mapId,
          }),
        );
      });

      return elements;
    },
    /**
     * 도형 오브젝트 생성
     * @author KangBonghun(toto1323)
     * @param  {[type]} objects [description]
     * @param  {[type]} point   [description]
     * @return {[type]}         [description]
     */
    createShapeModel(objects, point) {
      const elements = [];
      let maxZIndex = this.getMaxZIndex();

      objects.forEach((object, index) => {
        const size = 46;

        elements.push(
          new Q.ShapeModel({
            shapeType: object.shapeType,
            width: size,
            height: size,
            x: point.x + (size * (index % 10)),
            y: point.y + (size * parseInt(index / 10, 10)),
            r: 0,
            z: (maxZIndex += 1),
          }),
        );
      });

      return elements;
    },
    /**
     * 사용자 이미지 오브젝트 생성
     * @author KangBonghun(toto1323)
     * @param  {Array} objects 오브젝트 목록
     * @param  {Object} point   생성 할 좌표
     * @return {[type]}         [description]
     */
    createImageModel(objects, point) {
      const elements = [];
      let maxZIndex = this.getMaxZIndex();

      objects.forEach((object) => {
        elements.push(
          new Q.ImageModel({
            customimageId: object.customimageId,
            width: object.width,
            height: object.height,
            x: point.x,
            y: point.y,
            r: 0,
            z: (maxZIndex += 1),
          }),
        );
      });

      return elements;
    },
    /**
     * 라벨 오브젝트 생성
     * @author KangBonghun(toto1323)
     * @param  {Array} objects 오브젝트 목록
     * @param  {Object} point   생성 할 좌표
     * @return {[type]}         [description]
     */
    createLabelModel(objects, point) {
      const elements = [];
      let maxZIndex = this.getMaxZIndex();

      objects.forEach(() => {
        elements.push(
          new Q.LabelModel({
            x: point.x,
            y: point.y,
            r: 0,
            z: (maxZIndex += 1),
          }),
        );
      });

      return elements;
    },
    highlightLan(target) {
      // 기존 하이라이트 회선 원상복구
      if (window.highlightLanId) {
        const oldTarget = MapInfo.getInstance(this).getGraph().getElement(window.highlightLanId);
        if (oldTarget) {
          const oldModel = oldTarget.get('model');
          oldTarget.setStyle(Q.Styles.EDGE_WIDTH, oldModel.strokeOptions.weight);
        }

        window.highlightLanId = null;
      }

      // 마우스오버 된 회선 하이라이트
      if (target instanceof Q.LanModel) {
        const model = target.get('model');
        target.setStyle(Q.Styles.EDGE_WIDTH, model.strokeOptions.weight + 3);

        window.highlightLanId = target.id;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/topologymap/layout/TopologymapEdit.vue